import { arbHelper, goerHelper } from "./internalAddresses";
import { SupportedChainId } from "./chains";

export const ALL_HELPERS: { [key: number]: string } = {
  [SupportedChainId.ARBITRUM_ONE]: arbHelper,
  [SupportedChainId.GOERLI]: goerHelper,
};
